import styled from "styled-components";
import { SmallButton, WrapperContainer } from "../../components";
import { device } from "../../services";

export const StoresWrapper = styled(WrapperContainer)`
  width: 770px;

  @media screen and ${device.laptop} {
    width: 700px;
  }

  @media screen and ${device.tablet} {
    max-width: 525px;
    width: 100%;
  }
`;

export const NewButton = styled(SmallButton)`
  padding: 0 32px;
`;
